/*
 * @Description: 路由
 * @Date: 2024-11-16 13:13:03
 */

export const route = [
  {
    path: '/main/role-management',
    name: 'role-management',
    redirect: '/main/role-management/role-management-index',
    meta: {
      title: '员工管理'
    },
    children: [
      {
        path: '/main/role-management/role-management-index',
        name: 'role-management-index',
        meta: {
          title: '角色管理'
        },
        component: () => import('../views/role-management-index.vue')
      },
      {
        path: '/main/role-management/role-management-index/add',
        meta: {
          title: '角色管理',
          parentPath: '/main/role-management/role-management-index'
        },
        component: () => import('../views/role-management-change.vue')
      },
      {
        path: '/main/role-management/role-management-index/edit',
        meta: {
          title: '角色管理',
          parentPath: '/main/role-management/role-management-index'
        },
        component: () => import('../views/role-management-change.vue')
      }
    ]
  }
];
